import { Model, hasMany, belongsTo } from 'miragejs';
import attr from 'ember-data/attr';

export default Model.extend({
  rooms: hasMany('roomba/room'),
  company: belongsTo('roomba/company'),

  id: attr('string'),
  name: attr('string'),
  roomsNotificationEmails: attr('array'),
  roomsShouldEmailGlobalAdmins: attr('string'),
  roomsShouldEmailLocationAdmins: attr('string'),
  roomResizerEnabledOverride: attr('boolean'),
  onsiteRoomRecaptureEnabledOverride: attr('boolean'),
  roomResizerEnabled: attr('boolean'),
  onsiteRoomRecapture: attr('boolean'),
  roomsPreCheckInWindow: attr('number'),
  roomsPreCheckInWindowIsOverride: attr('boolean'),
  roomsCheckInWindow: attr('number'),
  roomsCheckInWindowIsOverride: attr('boolean'),
  roomCheckInEnabled: attr('boolean'),
});
